import { message } from 'antd';
import { translateExportStatus, getExportStatusColor } from './billI18n';

/**
 * 下载账单导出文件
 * @param fileUrl 文件URL
 * @param fileName 文件名
 */
export const downloadBillExportFile = (fileUrl: string, fileName: string) => {
  try {
    // 创建隐藏的a标签进行下载
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    message.success('文件下载已开始');
  } catch (error) {
    console.error('下载文件失败:', error);
    message.error('下载文件失败，请稍后重试');
  }
};

/**
 * 在新窗口打开文件URL
 * @param fileUrl 文件URL
 */
export const openBillExportFile = (fileUrl: string) => {
  try {
    window.open(fileUrl, '_blank');
  } catch (error) {
    console.error('打开文件失败:', error);
    message.error('打开文件失败，请稍后重试');
  }
};

/**
 * 格式化文件大小
 * @param bytes 字节数
 * @returns 格式化后的文件大小
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};

/**
 * 格式化导出状态（保留旧签名 {text, color}，内部走 i18n）
 */
export const formatExportStatus = (status: string): { text: string; color: string } => ({
  text: translateExportStatus(status),
  color: getExportStatusColor(status),
});

